import {
	RECEIVE_SESSION_USER,
	REQUEST_RESET_PASSWORD_EMAIL,
	COMPLETE_REQUEST_PASSWORD_EMAIL,
	COMPLETE_REQUEST_PASSWORD_EMAIL_ERROR,
	REQUEST_RESET_PASSWORD,
	COMPLETE_RESET_PASSWORD,
	COMPLETE_RESET_PASSWORD_ERROR,
	RECEIVE_TOKEN_VALIDATION_ERROR,
} from '../constants/ActionTypes';
import User from '../models/user';

const initialState = {
	user: new User(),
	error: null,
	success: null,
};

export default function auth (state = initialState, action) {
	switch (action.type) {
		case RECEIVE_SESSION_USER:
			return { ...state, user: new User(action.user) };

		case '@@router/LOCATION_CHANGE':
			return { ...state, error: null, success: null };

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/auth.js